import {combineReducers} from 'redux';
export function AppReducer(state = null, action: any) {
    switch (action.type) {
        default: return {state}
    }
}

const Reducer = combineReducers({AppReducer});
export default Reducer;
